export interface AuthenticationTask {
    id: string;
    type: string;
    authentication_data: string;
    status: TaskStatus;
    expenses: Expense[];
    created_at: string;
    expires_at: string;
    authenticated_at: string;
    authenticated_with_token_ids: string[];
    reject_code?: string;
    reject_description?: string;
    signer: Party;
    reference: string;
}

export interface PageOfAuthenticationTasks extends CursorPage {
    authentication_tasks: AuthenticationTask[];
}

export interface AuthenticationTaskSignabilityRequest {
    type: string;
    expenses: Expense[];
}

export interface CursorPage {
    next_cursor: string;
}

export interface Expense {
    type: ExpenseType;
    amount: Money;
}

export interface Money {
    amount: number;
    currency?: string;
}

export interface PageOfUserLimits extends CursorPage {
    user_limits: UserLimit[];
}

export interface TempLimit {
    start_at: string;
    ends_at: string;
    amount: number;
}

export interface Party {
    id: string;
    type: PartyType;
    eb_contract_id: string;
}

export interface UserLimit {
    id: string;
    authenticator_group_id: string;
    limit_type: ExpenseType;
    user: Party;
    amount: number;
    temp_limits?: TempLimit[];
}

export interface UserLimitPatch {
    amount: number;
    temp_limits: TempLimit[];
}

export enum ExpenseType {
    INTERNAL_ACCOUNT = 'internal_account',
    COUNTER_ACCOUNT = 'counter_account',
    EXTERNAL_ACCOUNT = 'external_account'
}

export enum PartyType {
    CUSTOMER = 'customer',
    EMPLOYEE = 'employee',
    PROSPECT = 'prospect',
    ANONYMOUS = 'anonymous'
}

/*
authenticated: Task has been authenticated
partially_authenticated_pending: Task is pending for additional authentication
partially_authenticated_expired: Task requires additional authentication, but has expired
unauthenticated_pending: Task is pending for initial authentication
unauthenticated_expired: Task has expired before authenticating
cancelled: Task has been cancelled before authentication
 */
export enum TaskStatus {
    AUTHENTICATED = 'authenticated',
    PARTIALLY_AUTHENTICATED_PENDING = 'partially_authenticated_pending',
    PARTIALLY_AUTHENTICATED_EXPIRED = 'partially_authenticated_expired',
    UNAUTHENTICATED_PENDING = 'unauthenticated_pending',
    UNAUTHENTICATED_EXPIRED = 'unauthenticated_expired',
    CANCELLED = 'cancelled'
}
